import React from 'react';
import { useAuth } from '../../auth/AuthContext';

/** Compact signed-in identity for page headers (email preferred; id as fallback/title). */
export default function SignedInUserLine({ className = '' }) {
  const { session, user } = useAuth();
  const email = session?.user?.email || user?.email || '';
  const id = session?.user?.id || user?.id || '';
  if (!email && !id) return null;

  return (
    <p
      className={`truncate text-[11px] leading-tight text-pp-muted ${className}`.trim()}
      title={id || email}
      data-tour="signed-in-user"
    >
      {email || `${id.slice(0, 8)}…`}
    </p>
  );
}
